import React from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import AuthLayout from "../../layouts/AuthLayout";
import FormField from "../../components/FormField";
import RippleButton from "../../components/buttons/RippleButton";
import { forgotPassword } from "../../redux/slices/authSlice";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.auth.loading);

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required")
      .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Invalid email address"),
  });

  const initialValues = {
    email: "",
    password: "",
  };

  return (
    <AuthLayout rightContainerClassName="mt-226-sigin">
      <section>
        <h5 className="fs-22 fw-600 text-gray-900">Forgot Password</h5>
      </section>
      <section style={{ marginTop: "22px", width: "100%" }}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            dispatch(forgotPassword({ data: values, navigate }));
            resetForm();
          }}
        >
          {() => (
            <Form className="row">
              <FormField
                label="User ID - Email Address"
                name="email"
                type="email"
                fieldSize="col-12"
                labelFontColor="text-gray-950"
                footerPlaceholder="Please enter your email"
              />
              <div className="d-flex justify-content-end auth-login-button">
                <RippleButton type="submit" isLoading={loading}>
                  {t("COMMON.SUBMIT")}
                </RippleButton>
              </div>
            </Form>
          )}
        </Formik>
      </section>
    </AuthLayout>
  );
};

export default ForgotPassword;
